import React, { useEffect, useState } from "react";
import { getAccTrans } from "../../../store/accTrans/action";
import { useDispatch, useSelector } from "react-redux";
import handleValidDate from "../../../helpers/utils/handleValidDate";

const PrintPdf = () => {
  const { companySelected, accTranss, accTransLoading, accAccounts, accAccountsLoading } = useSelector((state) => ({
    companySelected: state.App.companySelected,
    accTranss: state.AccTrans.accTranss,
    accTransLoading: state.AccTrans.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountsLoading: state.AccAccount.loading,
  }));

  const dispatch = useDispatch();

  const [dataTrans, setDataTrans] = useState([]);

  const handleClick = () => {
    const params = { companyId: companySelected?.value };
    dispatch(getAccTrans(params));
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  useEffect(() => {
    if (accAccounts.length > 0) {
      const grouped = accAccounts.map((acc) => ({
        ...acc,
        details: [],
      }));

      accTranss
        // .filter((trx) => trx.statusId === 3)
        .forEach((trx) => {
          trx.at_detail?.forEach((detail) => {
            // console.log("====");
            // console.log(detail);
            // console.log("====");

            const account = grouped.find((acc) => acc.id === detail.accId);

            if (account) {
              account.details.push({
                ...trx,
                at_detail: [detail],
              });
            }
          });
        });

      console.log(grouped, "ggg");

      setDataTrans(grouped);
    }
  }, [accTranss]);

  return (
    <>
      <button type="button" className="btn btn-warning add-btn me-2" id="create-btn" onClick={handleClick}>
        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tes Print
      </button>
      <div style={{ position: "absolute", backgroundColor: "white", zIndex: "100", left: 0, right: 0 }}>
        {dataTrans.map((account) => {
          let temp_saldo = account.close_balance;

          return (
            <div key={account.id}>
              <div className="fw-bold p-2 bg-light">
                <div>
                  ({account.code}) {account.name}
                </div>
              </div>

              <div className="d-flex justify-content-between p-2 border-bottom" style={{ width: "100%" }}>
                <div className="fw-bold" style={{ width: "12%" }}>
                  <div>{handleValidDate(account?.closeat ?? "", "DD/MM/YYYY")}</div>
                </div>
                <div className="fw-bold" style={{ width: "18%" }}>
                  <div>{"Saldo Awal"}</div>
                </div>
                <div className="fw-bold" style={{ width: "34%" }}>
                  <div></div>
                </div>
                <div className="fw-bold text-end" style={{ width: "12%" }}>
                  <div></div>
                </div>
                <div className="fw-bold text-end" style={{ width: "12%" }}>
                  <div></div>
                </div>
                <div className="fw-bold text-end" style={{ width: "12%" }}>
                  <div>{currencyFormat(Math.abs(account.close_balance))}</div>
                </div>
              </div>
              <div>
                {(account.details || [])
                  .sort((a, b) => {
                    return new Date(a?.transactionat).getTime() - new Date(b?.transactionat).getTime() || a?.code - b?.code;
                  })
                  .map((transaction, o) => {
                    return (
                      <div key={o}>
                        {(transaction.at_detail || []).map((trans, i) => {
                          let debit = trans.debit ? parseFloat(trans.debit) : 0;
                          let credit = trans.credit ? parseFloat(trans.credit) : 0;
                          if (debit > 0) {
                            temp_saldo = parseFloat(temp_saldo) + parseFloat(debit);
                          }
                          if (credit > 0) {
                            temp_saldo = parseFloat(temp_saldo) - parseFloat(credit);
                          }

                          return (
                            <div key={i} className="d-flex justify-content-between p-2 border-bottom" style={{ width: "100%" }}>
                              <div className="d-flex" style={{ width: "12%" }}>
                                <div>{handleValidDate(transaction?.transactionat, "DD/MM/YYYY")}</div>
                              </div>
                              <div className="" style={{ width: "18%" }}>
                                <div>{transaction?.transaction_no}</div>
                              </div>
                              <div className="" style={{ width: "34%" }}>
                                <div>{transaction?.description}</div>
                              </div>
                              <div className="text-end" style={{ width: "12%" }}>
                                <div>{trans ? currencyFormat(trans.debit) : 0}</div>
                              </div>
                              <div className="text-end" style={{ width: "12%" }}>
                                <div>{trans ? currencyFormat(trans.credit) : 0}</div>
                              </div>
                              <div className="text-end" style={{ width: "12%" }}>
                                <div>{account?.type === "DEBIT" && temp_saldo < 0 ? "( " + currencyFormat(Math.abs(temp_saldo)) + " )" : account?.type === "CREDIT" && temp_saldo > 0 ? "( " + currencyFormat(Math.abs(temp_saldo)) + " )" : currencyFormat(Math.abs(temp_saldo))}</div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
              </div>
              <div className="d-flex justify-content-between p-2 border-bottom" style={{ width: "100%" }}>
                <div className="d-flex" style={{ width: "12%" }}>
                  <div></div>
                </div>
                <div className="" style={{ width: "18%" }}>
                  <div></div>
                </div>
                <div className="text-end" style={{ width: "34%" }}>
                  <div>{`((${account.code}) ${account.name}) | Saldo Akhir`}</div>
                </div>
                <div className="text-end fw-bold" style={{ width: "12%" }}>
                  <div>{account.type === "DEBIT" && account.balance > 0 ? currencyFormat(account.balance) : 0}</div>
                </div>
                <div className="text-end fw-bold" style={{ width: "12%" }}>
                  <div>{account.type === "DEBIT" && account.balance > 0 ? 0 : account.balance === 0 ? 0 : `${currencyFormat(Math.abs(account.balance))}`}</div>
                </div>
                <div className="text-end fw-bold" style={{ width: "12%" }}>
                  <div>{account.type === "DEBIT" && account.balance > 0 ? currencyFormat(Math.abs(account.balance)) : account.balance === 0 ? 0 : `( ${currencyFormat(Math.abs(account.balance))} )`}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PrintPdf;
